import {
  browserLocalPersistence,
  browserSessionPersistence,
  getAuth,
  setPersistence,
  type Auth,
  type Persistence,
} from 'firebase/auth';
import type { FirebaseApp } from 'firebase/app';

export type FirebaseAuthPersistenceT = 'session' | 'local';

export type FirebaseAuthPersistenceErrorHandlerT = (error: unknown) => void;

export type CreateFirebaseAuthOptionsT = Readonly<{
  persistence: FirebaseAuthPersistenceT;
  onPersistenceError?: FirebaseAuthPersistenceErrorHandlerT;
}>;

function resolvePersistence(persistence: FirebaseAuthPersistenceT): Persistence {
  return persistence === 'session' ? browserSessionPersistence : browserLocalPersistence;
}

export function configureFirebaseAuthPersistence(
  auth: Auth,
  options: CreateFirebaseAuthOptionsT
): void {
  void setPersistence(auth, resolvePersistence(options.persistence)).catch((error: unknown) => {
    options.onPersistenceError?.(error);
  });
}

export function createFirebaseAuth(
  app: FirebaseApp,
  options: CreateFirebaseAuthOptionsT
): Auth {
  const auth = getAuth(app);
  configureFirebaseAuthPersistence(auth, options);
  return auth;
}
